import { useFormik } from 'formik';
import Products from '../interfaces/Product';
import { FormInterface } from '../../../core/interfaces/form/Form';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { useStore } from '../../../context/Store';
import { useSnackbar } from '../../../context/Snackbar';

export default function Form({ handleSubmitForm, initialValues, disabled }: FormInterface<Products>) {

  const { store } = useStore();
  const { setSnackbar } = useSnackbar();
  const { handleSubmit, handleChange, values } = useFormik<Products>({
    initialValues: initialValues,
    onSubmit: values => {
      handleClickSubmit();
    },
  });

  const handleClickSubmit = () => {
    let product: Products = { ...values };
    if (disabled) {
      product.DESCMERCA = '';
      product.MERCADORIA = '';
    } else if (!!values.DESCMERCA && !isNaN(Number(values.DESCMERCA))) {
      product.MERCADORIA = (`000000000000000000${values.DESCMERCA}`).slice(-18);
      product.EAN = '';
      product.DESCMERCA = '';
    } else {
      product.EAN = '';
      product.MERCADORIA = '';
    }
    if (store) {
      handleSubmitForm(product);
    } else {
      setSnackbar({ type: 'error', msg: 'Selecione uma loja' })
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <OutlinedInput
        name={disabled ? 'EAN' : "DESCMERCA"}
        value={disabled ? values.EAN : (values.DESCMERCA || values.MERCADORIA)}
        onChange={handleChange}
        type="text"
        fullWidth
        size='small'
        margin="dense"
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="Search"
              onClick={handleClickSubmit}
              size='small'
              color='primary'
            >
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        }
      />
    </form>
  )
}
